(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evening-morning"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  const clamp = n => Math.max(0, Math.min(1, n));
  const ease = n => { n=clamp(n); return n*n*(3-2*n); };
  function mount(root) {
    if (instances.has(root)) return;
    const stage=root.querySelector('.nc-calm__stage');
    const question=root.querySelector('.nc-calm__question');
    const lead=root.querySelector('.nc-calm__lead');
    const detail=root.querySelector('.nc-calm__detail');
    const ellipsis=root.querySelector('.nc-calm__ellipsis');
    const line=root.querySelector('.nc-calm__line');
    const notes=root.querySelector('.nc-calm__notes');
    const pixelWords=root.querySelectorAll('[data-pixel-word]');
    const media=matchMedia('(min-width:900px) and (prefers-reduced-motion:no-preference)');
    const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
    const coarsePointer=matchMedia('(hover: none), (pointer: coarse)');
    const finePointer=matchMedia('(hover: hover) and (pointer: fine)');
    let frame=0, active=true, enabled=false, height=0, travel=0, questionHeight=0;
    let pixelCycle=0, pixelFrame=0, pixelIndex=0, pixelVisible=false, activePixel=null;
    const pixelSurfaces=new Map();
    function getPixelSurface(word) {
      if (pixelSurfaces.has(word)) return pixelSurfaces.get(word);
      const canvas=document.createElement('canvas');
      const bands=document.createElement('canvas');
      const source=document.createElement('canvas');
      const low=document.createElement('canvas');
      const pixels=document.createElement('canvas');
      canvas.className='nc-calm__pixel-canvas';
      bands.className='nc-calm__pixel-bands';
      canvas.setAttribute('aria-hidden','true');
      bands.setAttribute('aria-hidden','true');
      word.append(canvas,bands);
      const surface={canvas,bands,source,low,pixels,width:0,height:0,fontSize:0};
      pixelSurfaces.set(word,surface);
      return surface;
    }
    function preparePixelSurface(word) {
      const text=word.querySelector('.nc-calm__pixel-text');
      const width=word.offsetWidth;
      const height=word.offsetHeight;
      if (!text || width<1 || height<1) return null;
      const style=getComputedStyle(text);
      const fontSize=parseFloat(style.fontSize) || 32;
      const dpr=Math.min(2,devicePixelRatio || 1);
      const surface=getPixelSurface(word);
      const {canvas,bands,source,low,pixels}=surface;
      const targetWidth=Math.max(1,Math.round(width*dpr));
      const targetHeight=Math.max(1,Math.round(height*dpr));
      if (canvas.width!==targetWidth || canvas.height!==targetHeight) {
        canvas.width=bands.width=source.width=pixels.width=targetWidth;
        canvas.height=bands.height=source.height=pixels.height=targetHeight;
      }
      const sourceContext=source.getContext('2d');
      sourceContext.setTransform(dpr,0,0,dpr,0,0);
      sourceContext.clearRect(0,0,width,height);
      const rgb=(style.color.match(/[\d.]+/g) || ['27','40','54']).slice(0,3).map(Number);
      const accent=word.closest('.nc-calm__detail') ? [126,82,43] : [166,111,62];
      const colorMix=word.closest('.nc-calm__detail') ? .32 : .42;
      const color=rgb.map((value,index)=>Math.round(value+(accent[index]-value)*colorMix));
      sourceContext.fillStyle=`rgb(${color.join(',')})`;
      sourceContext.font=`${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
      sourceContext.textAlign='center';
      sourceContext.textBaseline='middle';
      sourceContext.fillText(text.textContent,width/2,height/2+fontSize*.025,width);
      const isPhrase=word.dataset.pixelWord?.includes(' ');
      const pixelSize=isPhrase ? Math.min(14,Math.max(8,fontSize*.13)) : Math.min(11,Math.max(6,fontSize*.11));
      const verticalPixelSize=Math.max(4,pixelSize*.58);
      low.width=Math.max(1,Math.round(targetWidth/(pixelSize*dpr)));
      low.height=Math.max(1,Math.round(targetHeight/(verticalPixelSize*dpr)));
      const lowContext=low.getContext('2d');
      lowContext.imageSmoothingEnabled=true;
      lowContext.clearRect(0,0,low.width,low.height);
      lowContext.drawImage(source,0,0,source.width,source.height,0,0,low.width,low.height);
      const pixelContext=pixels.getContext('2d');
      pixelContext.imageSmoothingEnabled=false;
      pixelContext.clearRect(0,0,pixels.width,pixels.height);
      pixelContext.drawImage(low,0,0,low.width,low.height,0,0,pixels.width,pixels.height);
      surface.width=width;
      surface.height=height;
      surface.fontSize=fontSize;
      surface.dpr=dpr;
      return surface;
    }
    function drawPixelWord(word,strength,x,y) {
      const surface=preparePixelSurface(word);
      if (!surface) return;
      const {canvas,bands,pixels,width,height,fontSize,dpr}=surface;
      const isPhrase=word.dataset.pixelWord?.includes(' ');
      const radiusX=Math.min(width*.43,Math.max(30,fontSize*(isPhrase ? 1.18 : .68)));
      const radiusY=Math.min(height*.74,Math.max(16,fontSize*.38));
      const visibleRadius=Math.max(.01,Math.sqrt(strength));
      const rx=radiusX*visibleRadius;
      const ry=radiusY*visibleRadius;
      word.style.setProperty('--nc-pixel-strength',strength.toFixed(3));
      word.style.setProperty('--nc-pixel-x',`${x.toFixed(2)}px`);
      word.style.setProperty('--nc-pixel-y',`${y.toFixed(2)}px`);
      word.style.setProperty('--nc-pixel-rx',`${rx.toFixed(2)}px`);
      word.style.setProperty('--nc-pixel-ry',`${ry.toFixed(2)}px`);

      const context=canvas.getContext('2d');
      context.setTransform(dpr,0,0,dpr,0,0);
      context.clearRect(0,0,width,height);
      context.save();
      context.beginPath();
      context.ellipse(x,y,rx,ry,0,0,Math.PI*2);
      context.clip();
      context.drawImage(pixels,0,0,pixels.width,pixels.height,0,0,width,height);
      context.restore();

      const bandContext=bands.getContext('2d');
      bandContext.setTransform(dpr,0,0,dpr,0,0);
      bandContext.clearRect(0,0,width,height);
      const bandOffsets=[-.48,-.28,-.06,.14,.34,.5];
      const shifts=[13,-10,16,-14,9,-7];
      bandOffsets.forEach((offset,index)=>{
        const sy=Math.max(0,Math.min(height-1,y+radiusY*offset));
        const strip=Math.max(2,Math.min(4.6,fontSize*.034+(index%3)*.7));
        const sx=Math.max(0,x-radiusX*1.3);
        const sw=Math.min(width-sx,radiusX*2.6);
        const dx=sx+shifts[index]*strength;
        bandContext.globalAlpha=.94-(index*.055);
        bandContext.drawImage(pixels,sx*dpr,sy*dpr,sw*dpr,strip*dpr,dx,sy,sw,strip);
      });
      bandContext.globalAlpha=1;
    }
    function finishPixel(word) {
      word?.classList.remove('is-pixel');
      word?.style.removeProperty('--nc-pixel-strength');
      word?.style.removeProperty('--nc-pixel-x');
      word?.style.removeProperty('--nc-pixel-y');
      word?.style.removeProperty('--nc-pixel-rx');
      word?.style.removeProperty('--nc-pixel-ry');
      if (activePixel?.word===word) activePixel=null;
    }
    function clearPixel() {
      cancelAnimationFrame(pixelFrame);
      pixelFrame=0;
      pixelWords.forEach(finishPixel);
      activePixel=null;
    }
    function animatePixel(now) {
      if (!activePixel) return;
      activePixel.x+=(activePixel.targetX-activePixel.x)*.42;
      activePixel.y+=(activePixel.targetY-activePixel.y)*.42;
      const elapsed=Math.max(0,now - activePixel.started);
      const idle=Math.max(0,now - activePixel.lastMove);
      const attack=clamp(elapsed/45);
      const release=activePixel.auto ? clamp(1-(elapsed-360)/520) : clamp(1-(idle-90)/330);
      const strength=ease(Math.min(attack,release));
      drawPixelWord(activePixel.word,strength,activePixel.x,activePixel.y);
      if ((elapsed<80 || strength>.012) && pixelVisible && !reducedMotion.matches && !document.hidden) {
        pixelFrame=requestAnimationFrame(animatePixel);
      } else {
        finishPixel(activePixel.word);
        pixelFrame=0;
      }
    }
    function activatePixel(word,x,y,auto=false) {
      if (!pixelVisible || reducedMotion.matches || document.hidden || !word) return;
      const now=performance.now();
      if (!activePixel || activePixel.word!==word) {
        clearPixel();
        word.classList.add('is-pixel');
        activePixel={word,x,y,targetX:x,targetY:y,started:now,lastMove:now,auto};
      } else {
        activePixel.targetX=x;
        activePixel.targetY=y;
        activePixel.lastMove=now;
        activePixel.auto=auto;
      }
      if (!pixelFrame) pixelFrame=requestAnimationFrame(animatePixel);
    }
    function handlePixelMove(event) {
      if (!finePointer.matches) return;
      const word=event.currentTarget;
      const rect=word.getBoundingClientRect();
      activatePixel(word,Math.max(0,Math.min(rect.width,event.clientX-rect.left)),Math.max(0,Math.min(rect.height,event.clientY-rect.top)));
    }
    function handlePixelLeave(event) {
      if (activePixel?.word===event.currentTarget) activePixel.lastMove=Math.min(activePixel.lastMove,performance.now()-100);
    }
    function handlePixelFocus(event) {
      if (!finePointer.matches) return;
      const word=event.currentTarget;
      activatePixel(word,word.offsetWidth*.5,word.offsetHeight*.52,true);
    }
    function pulsePixel(word) {
      if (!word) return;
      const xPositions=[.34,.57,.72];
      const x=word.offsetWidth*xPositions[pixelIndex%xPositions.length];
      activatePixel(word,x,word.offsetHeight*.52,true);
    }
    function stopPixelCycle() {
      clearTimeout(pixelCycle);
      clearPixel();
    }
    function schedulePixelCycle(delay=1600) {
      clearTimeout(pixelCycle);
      if (!pixelVisible || reducedMotion.matches || !coarsePointer.matches || document.hidden) return;
      pixelCycle=setTimeout(()=>{
        if (!pixelVisible || reducedMotion.matches || document.hidden) return;
        pulsePixel(pixelWords[pixelIndex%pixelWords.length]);
        pixelIndex+=1;
        schedulePixelCycle(2900);
      },delay);
    }
    function paint() {
      frame=0;
      if (!enabled || !root.isConnected || document.hidden) return;
      const distance=-root.getBoundingClientRect().top;
      const y=Math.max(0,Math.min(travel,distance));
      const exit=Math.max(0,distance-travel);
      const p=y/travel;
      const shrink=ease(p/.65);
      const reveal=ease((p-.10)/.38);
      const complete=ease((p-.38)/.34);
      // Fade each complete text group before its first line reaches the viewport edge.
      const questionOut=1-ease((exit-height*.06)/(height*.08));
      const answerOut=1-ease((exit-height*.24)/(height*.12));
      stage.style.transform=`translate3d(0,${y}px,0)`;
      question.style.transform=`translate3d(0,calc(-50% - ${height*.26*shrink}px),0) scale(${1-.72*shrink})`;
      question.style.opacity=String(questionOut);
      lead.style.opacity=String(reveal*answerOut);
      const questionBottom=height*(.46-.26*shrink)+questionHeight*.5*(1-.72*shrink);
      const leadOffset=Math.max(40*(1-reveal),questionBottom+32-height*.40);
      lead.style.transform=`translate3d(0,${leadOffset}px,0)`;
      detail.style.opacity=String(complete*answerOut);
      detail.style.transform=`translate3d(0,${24*(1-complete)}px,0)`;
      ellipsis.style.opacity=String(1-complete);
      line.style.opacity=String(ease((shrink-.75)/.25)*questionOut);
      line.style.transform=`scaleX(${shrink})`;
      notes.style.opacity=String(ease((p-.58)/.18)*answerOut);
    }
    function schedule() { if(enabled && active && !frame && !document.hidden) frame=requestAnimationFrame(paint); }
    function configure() {
      cancelAnimationFrame(frame);frame=0;enabled=media.matches;
      [stage,question,lead,detail,ellipsis,line,notes].forEach(el=>el.removeAttribute('style'));
      if(enabled) {
        height=Math.min(740,Math.max(520,innerHeight*.76));
        travel=Math.min(560,Math.max(420,innerHeight*.56));
        root.style.setProperty('--nc-calm-stage',height+'px');
        root.style.setProperty('--nc-calm-travel',travel+'px');
        root.setAttribute('data-animated','');
        questionHeight=question.offsetHeight;
        paint();
      } else {
        root.removeAttribute('data-animated');
        root.style.removeProperty('--nc-calm-stage');
        root.style.removeProperty('--nc-calm-travel');
      }
    }
    const observer='IntersectionObserver' in window ? new IntersectionObserver(entries=>{
      active=entries[0].isIntersecting;
      if(active) schedule(); else {cancelAnimationFrame(frame);frame=0;}
    },{rootMargin:'150px'}) : null;
    const pixelObserver='IntersectionObserver' in window ? new IntersectionObserver(entries=>{
      pixelVisible=entries[0].isIntersecting;
      if(pixelVisible)schedulePixelCycle();else stopPixelCycle();
    },{threshold:.18}) : null;
    observer?.observe(root);
    pixelObserver?.observe(root);
    pixelWords.forEach(word=>{
      word.addEventListener('pointermove',handlePixelMove,{passive:true});
      word.addEventListener('pointerleave',handlePixelLeave,{passive:true});
      word.addEventListener('focus',handlePixelFocus);
    });
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',configure,{passive:true});
    function handleVisibility(){schedule();if(document.hidden)stopPixelCycle();else schedulePixelCycle(900);}
    function handlePixelMedia(){if(reducedMotion.matches)stopPixelCycle();else schedulePixelCycle(900);}
    document.addEventListener('visibilitychange',handleVisibility);
    media.addEventListener('change',configure);
    reducedMotion.addEventListener('change',handlePixelMedia);
    coarsePointer.addEventListener('change',handlePixelMedia);
    configure();
    instances.set(root,()=>{
      observer?.disconnect();pixelObserver?.disconnect();cancelAnimationFrame(frame);stopPixelCycle();
      window.removeEventListener('scroll',schedule);window.removeEventListener('resize',configure);
      pixelWords.forEach(word=>{
        word.removeEventListener('pointermove',handlePixelMove);
        word.removeEventListener('pointerleave',handlePixelLeave);
        word.removeEventListener('focus',handlePixelFocus);
      });
      document.removeEventListener('visibilitychange',handleVisibility);media.removeEventListener('change',configure);
      reducedMotion.removeEventListener('change',handlePixelMedia);coarsePointer.removeEventListener('change',handlePixelMedia);
    });
  }
  function scan(scope){scope.querySelectorAll('[data-nc-calm]').forEach(mount);}
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>instances.forEach((dispose,root)=>{
    if(e.target.contains(root)){dispose();instances.delete(root);}
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expert-routine-morning"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = window.__nocteraExpertNative || (window.__nocteraExpertNative = new Map());
  const clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));

  function mount(root) {
    if (instances.has(root)) return;

    const portraits = [...root.querySelectorAll('[data-expert-portrait]')];
    const chapters = [...root.querySelectorAll('[data-expert-chapter]')];
    const dots = [...root.querySelectorAll('[data-expert-dot]')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 899px)');
    let active = -1;
    let frame = 0;
    let visible = true;
    let observer;

    function stateFor(index, current) {
      const distance = index - current;
      if (distance === 0) return 'active';
      if (distance === -1) return 'before';
      if (distance === 1) return 'after';
      return distance < 0 ? 'far-before' : 'far-after';
    }

    function setActive(index) {
      const next = Math.max(0, Math.min(chapters.length - 1, index));
      if (next === active) return;
      active = next;
      root.dataset.active = String(next);
      portraits.forEach((portrait, itemIndex) => {
        portrait.dataset.state = stateFor(itemIndex, next);
        portrait.classList.toggle('is-active', itemIndex === next);
      });
      chapters.forEach((chapter, itemIndex) => chapter.classList.toggle('is-active', itemIndex === next));
      dots.forEach((dot) => dot.classList.toggle('is-active', Number(dot.dataset.index) === next));
    }

    function clearMotionStyles() {
      root.style.removeProperty('--story-progress');
      chapters.forEach((chapter) => {
        chapter.style.removeProperty('--chapter-opacity');
        chapter.style.removeProperty('--chapter-y');
      });
    }

    function paint() {
      frame = 0;
      if (!root.isConnected || document.hidden || reduced.matches) return;
      if (!visible) return;

      const viewportHeight = Math.max(window.innerHeight, 1);
      const target = viewportHeight * (mobile.matches ? .69 : .52);
      const rootRect = root.getBoundingClientRect();
      const travel = Math.max(rootRect.height - viewportHeight * .7, 1);
      const progress = clamp((target - rootRect.top) / travel);
      root.style.setProperty('--story-progress', progress.toFixed(4));

      let nearest = 0;
      let nearestDistance = Infinity;
      chapters.forEach((chapter, index) => {
        const rect = chapter.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const distance = Math.abs(center - target);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = index;
        }
        const nearness = clamp(1 - distance / (viewportHeight * .78));
        chapter.style.setProperty('--chapter-opacity', (.36 + nearness * .64).toFixed(3));
        chapter.style.setProperty('--chapter-y', ((1 - nearness) * 22).toFixed(1) + 'px');
      });
      setActive(nearest);
      root.dataset.motion = 'active';
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(paint);
    }

    function configureMotion() {
      cancelAnimationFrame(frame);
      frame = 0;
      if (reduced.matches) {
        root.dataset.motion = 'reduced';
        clearMotionStyles();
        setActive(0);
      } else {
        root.dataset.motion = 'active';
        schedule();
      }
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    reduced.addEventListener('change', configureMotion);
    mobile.addEventListener('change', schedule);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        visible = entries[0]?.isIntersecting === true;
        root.classList.toggle('is-visible', visible);
        if (visible) schedule();
      }, { rootMargin: '22% 0px 22% 0px', threshold: 0 });
      observer.observe(root);
    }

    setActive(0);
    configureMotion();

    instances.set(root, () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      reduced.removeEventListener('change', configureMotion);
      mobile.removeEventListener('change', schedule);
      observer?.disconnect();
      clearMotionStyles();
    });
  }

  function scan(scope) {
    if (scope.matches?.('[data-expert-story]')) mount(scope);
    scope.querySelectorAll?.('[data-expert-story]').forEach(mount);
  }

  scan(document);
  if (!window.__nocteraExpertNativeEditorListeners) {
    window.__nocteraExpertNativeEditorListeners = true;
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      instances.forEach((dispose, root) => {
        if (event.target.contains(root)) {
          dispose();
          instances.delete(root);
        }
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noctera-night-order"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('noctera-ritual')) return;
  customElements.define('noctera-ritual', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.answer = this.querySelector('[data-ritual-answer]');
      this.copy = this.querySelector('[data-ritual-copy]');
      this.cta = this.querySelector('[data-ritual-cta]');
      this.choices = [...this.querySelectorAll('[data-ritual-choice]')];
      this.index = 0;
      this.userPauseUntil = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onChoice = event => {
        const index = this.choices.indexOf(event.currentTarget);
        this.userPauseUntil = Date.now() + 12000;
        this.activate(index);
      };
      this.onEnter = event => {
        if (!window.matchMedia('(hover: hover)').matches) return;
        this.activate(this.choices.indexOf(event.currentTarget));
      };
      this.choices.forEach(choice => {
        choice.addEventListener('click', this.onChoice);
        choice.addEventListener('pointerenter', this.onEnter);
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.classList.toggle('is-visible', this.visible);
      }, { threshold: .35 });
      this.observer.observe(this);
      this.dataset.active = '0';
      if (!this.reduced) {
        this.timer = window.setInterval(() => {
          if (!this.visible || Date.now() < this.userPauseUntil) return;
          this.activate((this.index + 1) % this.choices.length);
        }, 4200);
      }
    }
    activate(index) {
      if (index < 0 || index === this.index || !this.choices[index]) return;
      const choice = this.choices[index];
      this.classList.add('is-changing');
      window.clearTimeout(this.swapTimer);
      this.swapTimer = window.setTimeout(() => {
        this.index = index;
        this.dataset.active = String(index);
        this.answer.textContent = choice.dataset.answer;
        this.copy.textContent = choice.dataset.copy;
        this.cta.href = choice.dataset.url;
        this.choices.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        this.classList.remove('is-changing');
      }, this.reduced ? 0 : 190);
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      window.clearTimeout(this.swapTimer);
      if (this.observer) this.observer.disconnect();
      this.choices?.forEach(choice => {
        choice.removeEventListener('click', this.onChoice);
        choice.removeEventListener('pointerenter', this.onEnter);
      });
      this.initialized = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
